import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';
import {reportsService} from '@store/reports/reports.service';
import {ReportState} from '@store/reports/reports.store';

type SearchReportsParams = Partial<ReportState>

export const searchReportsEffect = createEffectFn((params$: Observable<SearchReportsParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => reportsService.getReports().pipe(catchError(() => EMPTY))),
  );
});
